import { useState } from "react";
import { Link } from "react-router-dom";
import DropdownUser from "./DropdownUser";
import LogoIconLight from "../../images/logo/logo-icon.svg";
import LogoIconDark from "../../images/logo/logo-icon-dark.svg";
import DarkModeSwitcher from "./DarkModeSwitcher";
import HeaderSearchBar from "../HeaderSearchBar/HeaderSearchBar.tsx";
import ReportProblemModal from "../Modals/ReportProblemModal";

const Header = ({
  sidebarOpen,
  setSidebarOpen,
  desktopSidebarOpen,
  setDesktopSidebarOpen,
}: {
  sidebarOpen: string | boolean | undefined;
  setSidebarOpen: (arg0: boolean) => void;
  desktopSidebarOpen: boolean;
  setDesktopSidebarOpen: (arg0: boolean) => void;
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <header className="drop-shadow-1 dark:bg-boxdark sticky top-0 z-[9999] flex w-full bg-white dark:drop-shadow-none">
        <div className="shadow-2 border-stroke/30 dark:border-strokedark/30 flex flex-grow items-center justify-between border-b px-4 py-4 md:px-6 2xl:px-11">
          <div className="flex items-center gap-2 sm:gap-4">
            <button
              aria-controls="sidebar"
              onClick={(e) => {
                e.stopPropagation();
                setSidebarOpen(!sidebarOpen);
              }}
              className="border-stroke dark:border-strokedark dark:bg-boxdark hover:border-secondary hover:bg-secondary/8 dark:hover:border-secondary dark:hover:bg-secondary/15 group rounded-sm border bg-white p-1.5 shadow-sm transition-all duration-200 lg:hidden"
            >
              <span className="h-5.5 w-5.5 relative block cursor-pointer">
                <i className="fa-solid fa-bars hover:text-secondary text-sm text-black transition-colors duration-200 dark:text-white" />
              </span>
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                setDesktopSidebarOpen(!desktopSidebarOpen);
              }}
              className="border-stroke dark:border-strokedark dark:bg-boxdark hover:border-accent/10 hover:bg-secondary/8 dark:hover:border-secondary dark:hover:bg-secondary/15 group hidden items-center justify-center gap-1.5 rounded-sm border bg-white px-3 py-1.5 shadow-sm transition-all duration-200 lg:flex"
              aria-label={desktopSidebarOpen ? "Close sidebar" : "Open sidebar"}
            >
              <i
                className={`fa-solid ${
                  desktopSidebarOpen ? "fa-arrow-left" : "fa-bars"
                } group-hover:text-accent text-sm text-black transition-colors duration-200 dark:text-white`}
              />
            </button>

            <div className="flex h-16 items-center justify-center lg:hidden">
              <Link className="block flex-shrink-0" to="/">
                <img
                  src={LogoIconDark}
                  alt="Logo"
                  className="block dark:hidden"
                />
                <img
                  src={LogoIconLight}
                  alt="Logo"
                  className="hidden dark:block"
                />
              </Link>
            </div>

            <div className="ml-4 hidden sm:block">
              <HeaderSearchBar />
            </div>
          </div>

          <div className="2xsm:gap-7 flex items-center gap-3">
            <ul className="2xsm:gap-4 flex items-center gap-2">
              <DarkModeSwitcher />
            </ul>

            <DropdownUser />

            <button
              type="button"
              title="Съобщаване за проблем"
              onClick={() => setShowModal(true)}
              className="text-bodydark1 hover:text-accent hover:bg-accent/10 dark:hover:text-accent-light dark:hover:bg-accent/10 rounded-md p-2 transition-colors duration-200 dark:text-slate-400"
            >
              <i className="fa-solid fa-triangle-exclamation text-lg"></i>
            </button>
          </div>
        </div>
      </header>

      {showModal && <ReportProblemModal onClose={() => setShowModal(false)} />}
    </>
  );
};

export default Header;
